import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../../app.constant';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';

import { Program } from 'src/app/shared/class/program';
import { Module } from 'src/app/shared/class/module';

@Component({
  selector: 'app-subject-table',
  templateUrl: './subject-table.component.html',
  styleUrls: ['./subject-table.component.css']
})
export class SubjectTableComponent implements OnInit {
  subjectForm:FormGroup; 
  programs:any;
  errorMessage:any;
  module:any;
  modules:any;

  selectedProgram:Program = new Program (1,'ABC','asd','sadasdsa');
  constructor(private formbuilder:FormBuilder,
    private _programservice:ProgramService,
    private _moduleservice:ModuleService,) { }


  ngOnInit() {
     this.subjectForm = this.formbuilder.group({
       'FK_ProgramID':[''],
       'FK_ModuleID':[''],
      'SubjectEntities' : this.formbuilder.array([])
     })
     this.getModuleByProgramID(this.selectedProgram.PK_ProgramID);
     this.getAllProgram();
  }
 
  // BGCSE
  get SUBJECTForm() {
    return this.subjectForm.get('SubjectEntities') as FormArray
  }

  addSubject(){
    const SUBJECTfb = this.formbuilder.group({
      PK_SubjectID : [],
      SubjectName : [],
      SubjectCode:[]
    })
    this.SUBJECTForm.push(SUBJECTfb);
  }

  deleteSubject(i){
    alert(i);
        this.SUBJECTForm.removeAt(i)
  }

  getAllProgram() :void  {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
   data =>
      {
        this.programs=data;
   },
   error => this.errorMessage = <any>error)
 }

getModuleByProgramID(PK_ProgramID) :void  {
 this._moduleservice.getAllModule(AppSettings.API_ENDPOINT+AppSettings.GetAllModule).subscribe(
 data =>
   {
     this.module=data;
     this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
},
error => this.errorMessage = <any>error)
 }

}
